module.exports = __webpack_public_path__ + "static/media/facebook-icon.9a5cd15e.svg";